import { useEffect, useState } from "react";
import style from "./Chatroom.module.css";
import { adminRequester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import Inline from "layouts/container/Inline";
import CustomIcon from "components/icons/CustomIcon";

function ChatroomListCard() {
  const [mounted, setMounted] = useState(false);
  const [data, setData] = useState();
  useEffect(() => setMounted(true), []);
  useEffect(() => {
    if (mounted) {
      adminRequester.getChatroomStatus({ status: "now" }, (result) =>
        setData(result?.data)
      );
    }
  }, [mounted]);
  const dataset = [
    {
      title: "관리자 채팅방",
      new: (data && data?.admin) || 0,
      max: 200,
      line: true,
    },
    {
      title: "판매자 채팅방",
      new: (data && data?.user) || 0,
      max: 200,
      line: true,
    },
    {
      title: "고객 채팅방",
      new: (data && data?.customer) || 0,
      max: 200,
    },
  ];
  const Content = (props) => {
    const { data } = props;
    return (
      <FlexChild>
        {data && (
          <VerticalFlex>
            <FlexChild>
              <div className={style.contentArea}>
                {data && (
                  <HorizontalFlex gap={20}>
                    <FlexChild>{data.title}</FlexChild>
                    <FlexChild width={"max-content"}>
                      <HorizontalFlex gap={20}>
                        {/* <FlexChild width={"max-content"}>
                          <P size={15}>신규</P>
                        </FlexChild> */}
                        <FlexChild>
                          <P
                            color={"var(--main-color)"}
                            size={20}
                            weight={"bold"}
                          >
                            {data.new}
                          </P>
                        </FlexChild>
                        <FlexChild>
                          <P>개</P>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    {/* <FlexChild width={"max-content"}>/</FlexChild>
                    <FlexChild width={"max-content"}>
                      <Inline>
                        <P weight={"bold"} color={"#5471e6"} size={20}>
                          {data.max}
                        </P>
                        <P size={15}> 개</P>
                      </Inline>
                    </FlexChild> */}
                  </HorizontalFlex>
                )}
              </div>
            </FlexChild>
            {data.line && (
              <FlexChild>
                <div className={style.line} />
              </FlexChild>
            )}
          </VerticalFlex>
        )}
      </FlexChild>
    );
  };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex gap={10}>
              <FlexChild width={"max-content"}>
                <CustomIcon name={"articleOperStatus"} width={20} />
              </FlexChild>
              <FlexChild>
                <P>채팅방 운영 현황</P>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.contentWrap}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.topWrap}>
                  <HorizontalFlex>
                    <FlexChild>
                      <P weight={"bold"} size={17}>
                        현재 운영 채팅방
                      </P>
                    </FlexChild>
                    <FlexChild justifyContent={"flex-end"}>
                      <Inline>
                        <P
                          weight={"bold"}
                          size={20}
                          color={"var(--main-color)"}
                        >
                          {(data && data.total) || 0}
                        </P>
                        <P size={15}> 개</P>
                      </Inline>
                    </FlexChild>
                  </HorizontalFlex>
                </div>
              </FlexChild>
              <FlexChild>
                <VerticalFlex>
                  {dataset &&
                    dataset.map((row, index) => (
                      <Content key={index} data={row} />
                    ))}
                </VerticalFlex>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}
export default ChatroomListCard;
